import { create } from 'zustand';
import { api } from '@/shared/lib/api';
import { captureError } from '@/shared/lib/monitoring';

interface CharacterStats {
  strength: number;
  dexterity: number;
  intelligence: number;
  luck: number;
  humor: number;
}

interface ItemDef {
  id: number;
  name: string;
  name_ru: string;
  description: string;
  description_ru: string;
  rarity: string;
  slot: string;
  flavor_text: string;
  str_bonus: number;
  dex_bonus: number;
  int_bonus: number;
  luck_bonus: number;
  humor_bonus: number;
}

interface InventoryItem {
  id: number;
  item_def: ItemDef;
  acquired_at: string;
  is_equipped: boolean;
  equipped_slot: string | null;
}

interface RpgState {
  character: {
    id: number;
    name: string;
    level: number;
    xp: number;
    xp_to_next_level: number;
    stats: CharacterStats;
    equipped: Record<string, InventoryItem>;
    inventory: InventoryItem[];
  } | null;
  isLoaded: boolean;

  load: () => Promise<void>;
  equip: (itemId: number) => Promise<void>;
  unequip: (itemId: number) => Promise<void>;
  rename: (name: string) => Promise<void>;
}

export const useRpgStore = create<RpgState>((set) => ({
  character: null,
  isLoaded: false,

  load: async () => {
    try {
      const data = await api.get<any>('/rpg/character');
      set({ character: data, isLoaded: true });
    } catch (err) {
      captureError(err, { context: 'rpgStore.load' });
      set({ isLoaded: true });
    }
  },

  equip: async (itemId: number) => {
    await api.post(`/rpg/equip/${itemId}`, {});
    // Перезагружаем персонажа
    const data = await api.get<any>('/rpg/character');
    set({ character: data });
  },

  unequip: async (itemId: number) => {
    await api.post(`/rpg/unequip/${itemId}`, {});
    const data = await api.get<any>('/rpg/character');
    set({ character: data });
  },

  rename: async (name: string) => {
    await api.patch('/rpg/character/name', { name });
    set(state => state.character
      ? { character: { ...state.character, name } }
      : state
    );
  },
}));
